import { AxiosResponse } from 'axios';
import qs from 'qs';
import { TeamSetting } from '@invideoio/web-shared/lib/API/team-setting';
import { ConfigType, InviteResponseType } from 'src/types';

import { API } from './index';
import { FeatureConfig } from '@invideoio/web-shared/types/Config';

async function fetchConfig() {
  const configURL = `${process.env.NEXT_PUBLIC_CONFIG_URL}`;

  const response: AxiosResponse<ConfigType> = await API.get(configURL);
  const { data: config } = response;

  return config;
}

async function getInvite(paramToken?: string) {
  try {
    let inviteResponse: AxiosResponse<InviteResponseType>;

    inviteResponse = await TeamSetting.fetchInviteData(paramToken);

    if (inviteResponse) {
      const { data, error_code, message } = inviteResponse.data;

      return {
        ...data,
        error_code,
        message,
      };
    }
  } catch (error: any) {
    console.log(error.message);
  }

  return;
}

async function fetchFeatureJson(): Promise<FeatureConfig | null> {
  const response: AxiosResponse<FeatureConfig> = await API.get(
    String(process.env.NEXT_PUBLIC_FEATURE_JSON_URL),
  );

  if (response.data) {
    return response.data;
  } else {
    return null;
  }
}

export { fetchConfig, getInvite, fetchFeatureJson };
